import React from 'react';
import Layout from "./layout";
import Method from "./components/Method";

const Errors = (props) => {
    return (
        <Layout children={props.children} location={props.location}>
            <div className="row">
                <div className="col-md-8">
                    <h1>Errors </h1>
                    <br/>
                    <p>
                        Biteship uses conventional HTTP response codes to show success or failure of an API request.
                        Codes in the 2xx range shows a success, codes for the 4xx range shows an error that resulted from the provided information (e.g. a required field was missing, wrong format, etc.), and codes in the 5xx range indicate an error with Biteship's servers.
                    </p>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-md-8">
                    <h2 className="h3">Code Summary</h2>
                    <br/>
                    <Method title={"HTTP STATUS CODE SUMMARY"} white>
                        <p><b>200</b> - Works fine.</p>
                        <p><b>400</b> - Bad request. Missing required parameters or other else.</p>
                        <p><b>401</b> - Request is not authorized</p>
                        <p><b>402</b> - Request is failed </p>
                        <p><b>403</b> - Key doesn't have access to request API calls</p>
                        <p><b>404</b> - The request is not exist</p>
                        <p><b>500</b> - Something's wrong with Biteship's internal server</p>
                    </Method>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-md-8">
                    <h2 className="h3">Example</h2>
                    <br/>
                    <p>This is how Biteship respond to error request</p>
                    <Method title={"HTTP ERROR RESPONSE"} white>
                        <p>{`{`} <br/>
                            <div className="text-indent-1">success: <b className="text-primary ">false</b>, <br/></div>
                            <div className="text-indent-1">error: <text className="text-swift-pink">"Required parameter is missing"</text> <br/></div>
                            {`}`}
                        </p>
                    </Method>
                </div>
            </div>
            <br/>
        </Layout>
    )
};

export default Errors
